export enum ImportTypes {
  UPDATE_DATA_BASE,
  IMPORT_MY_GTINS,
  CREATE_GTINS,
  IMPORT_MIGRATION_GPC,
  DEFAULT
}
